module.exports = __webpack_public_path__ + "static/img/WH-CH510.00be6c5c.jpg";